"use strict";

var PFAddressService = require('./pf-address-service').default;
var SmartyStreetsService = require('./smarty-streets-service').default;
var defaultService = new SmartyStreetsService(PFAddressService.defaultProps.smartystreetsconfig);
var validateAddressIsResidential = function validateAddressIsResidential(addressData) {
  return defaultService.validateAddressIsResidential(addressData);
};
module.exports = {
  PFAddressService: PFAddressService,
  validateAddressIsResidential: validateAddressIsResidential
};
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-address-service/dist/pf-address-service.scss');